import { AssetSvgProps } from "../../../shared/assets"
function ObjMor076({ className, onClick, outerTransform, transform, startDrag }: AssetSvgProps) {
    return (
        <g transform={outerTransform}><g className={className} onClick={onClick} transform={transform} onMouseDown={startDrag} onTouchStart={startDrag}><defs>
                <radialGradient
                    id="ObjMor076__Gradient_1"
                    gradientUnits="userSpaceOnUse"
                    cx={0}
                    cy={0}
                    r={10.688}
                    fx={0}
                    fy={0}
                    gradientTransform="translate(283.85 264.85)"
                    spreadMethod="pad"
                >
                    <stop
                        offset="18.824%"
                        stopColor="#FFF"
                        stopOpacity={0.251}
                    />
                    <stop
                        offset="63.137%"
                        stopColor="#DEF3FF"
                        stopOpacity={0.498}
                    />
                    <stop offset="100%" stopColor="#ADE1FF" />
                </radialGradient>
                <radialGradient
                    id="ObjMor076__Gradient_2"
                    gradientUnits="userSpaceOnUse"
                    cx={0}
                    cy={0}
                    r={16.075}
                    fx={0}
                    fy={0}
                    gradientTransform="translate(251.55 235.75)"
                    spreadMethod="pad"
                >
                    <stop
                        offset="18.824%"
                        stopColor="#FFF"
                        stopOpacity={0.251}
                    />
                    <stop
                        offset="63.137%"
                        stopColor="#DEF3FF"
                        stopOpacity={0.498}
                    />
                    <stop offset="100%" stopColor="#ADE1FF" />
                </radialGradient>
                <radialGradient
                    id="ObjMor076__Gradient_3"
                    gradientUnits="userSpaceOnUse"
                    cx={0}
                    cy={0}
                    r={6.988}
                    fx={0}
                    fy={0}
                    gradientTransform="translate(241.4 206.4)"
                    spreadMethod="pad"
                >
                    <stop
                        offset="18.824%"
                        stopColor="#FFF"
                        stopOpacity={0.251}
                    />
                    <stop
                        offset="63.137%"
                        stopColor="#DEF3FF"
                        stopOpacity={0.498}
                    />
                    <stop offset="100%" stopColor="#ADE1FF" />
                </radialGradient>
                <radialGradient
                    id="ObjMor076__Gradient_4"
                    gradientUnits="userSpaceOnUse"
                    cx={0}
                    cy={0}
                    r={6.813}
                    fx={0}
                    fy={0}
                    gradientTransform="translate(297.25 238.05)"
                    spreadMethod="pad"
                >
                    <stop
                        offset="18.824%"
                        stopColor="#FFF"
                        stopOpacity={0.251}
                    />
                    <stop
                        offset="63.137%"
                        stopColor="#DEF3FF"
                        stopOpacity={0.498}
                    />
                    <stop offset="100%" stopColor="#ADE1FF" />
                </radialGradient>
                <radialGradient
                    id="ObjMor076__Gradient_5"
                    gradientUnits="userSpaceOnUse"
                    cx={0}
                    cy={0}
                    r={15.875}
                    fx={0}
                    fy={0}
                    gradientTransform="translate(286.8 197.7)"
                    spreadMethod="pad"
                >
                    <stop
                        offset="18.824%"
                        stopColor="#FFF"
                        stopOpacity={0.251}
                    />
                    <stop
                        offset="63.137%"
                        stopColor="#DEF3FF"
                        stopOpacity={0.498}
                    />
                    <stop offset="100%" stopColor="#ADE1FF" />
                </radialGradient>
                <radialGradient
                    id="ObjMor076__Gradient_6"
                    gradientUnits="userSpaceOnUse"
                    cx={0}
                    cy={0}
                    r={6.813}
                    fx={0}
                    fy={0}
                    gradientTransform="translate(265.5 107.45)"
                    spreadMethod="pad"
                >
                    <stop
                        offset="18.824%"
                        stopColor="#FFF"
                        stopOpacity={0.251}
                    />
                    <stop
                        offset="63.137%"
                        stopColor="#DEF3FF"
                        stopOpacity={0.498}
                    />
                    <stop offset="100%" stopColor="#ADE1FF" />
                </radialGradient>
                <radialGradient
                    id="ObjMor076__Gradient_7"
                    gradientUnits="userSpaceOnUse"
                    cx={0}
                    cy={0}
                    r={10.688}
                    fx={0}
                    fy={0}
                    gradientTransform="translate(288.75 145.15)"
                    spreadMethod="pad"
                >
                    <stop
                        offset="18.824%"
                        stopColor="#FFF"
                        stopOpacity={0.251}
                    />
                    <stop
                        offset="63.137%"
                        stopColor="#DEF3FF"
                        stopOpacity={0.498}
                    />
                    <stop offset="100%" stopColor="#ADE1FF" />
                </radialGradient>
                <radialGradient
                    id="ObjMor076__Gradient_8"
                    gradientUnits="userSpaceOnUse"
                    cx={0}
                    cy={0}
                    r={6.813}
                    fx={0}
                    fy={0}
                    gradientTransform="translate(275.1 94.05)"
                    spreadMethod="pad"
                >
                    <stop
                        offset="18.824%"
                        stopColor="#FFF"
                        stopOpacity={0.251}
                    />
                    <stop
                        offset="63.137%"
                        stopColor="#DEF3FF"
                        stopOpacity={0.498}
                    />
                    <stop offset="100%" stopColor="#ADE1FF" />
                </radialGradient>
                <radialGradient
                    id="ObjMor076__Gradient_9"
                    gradientUnits="userSpaceOnUse"
                    cx={0}
                    cy={0}
                    r={6.813}
                    fx={0}
                    fy={0}
                    gradientTransform="translate(333.8 214.45)"
                    spreadMethod="pad"
                >
                    <stop
                        offset="18.824%"
                        stopColor="#FFF"
                        stopOpacity={0.251}
                    />
                    <stop
                        offset="63.137%"
                        stopColor="#DEF3FF"
                        stopOpacity={0.498}
                    />
                    <stop offset="100%" stopColor="#ADE1FF" />
                </radialGradient>
                <radialGradient
                    id="ObjMor076__Gradient_10"
                    gradientUnits="userSpaceOnUse"
                    cx={0}
                    cy={0}
                    r={15.875}
                    fx={0}
                    fy={0}
                    gradientTransform="translate(343.65 173.9)"
                    spreadMethod="pad"
                >
                    <stop
                        offset="18.824%"
                        stopColor="#FFF"
                        stopOpacity={0.251}
                    />
                    <stop
                        offset="63.137%"
                        stopColor="#DEF3FF"
                        stopOpacity={0.498}
                    />
                    <stop offset="100%" stopColor="#ADE1FF" />
                </radialGradient>
                <radialGradient
                    id="ObjMor076__Gradient_11"
                    gradientUnits="userSpaceOnUse"
                    cx={0}
                    cy={0}
                    r={21.462}
                    fx={0}
                    fy={0}
                    gradientTransform="translate(321.05 115.85)"
                    spreadMethod="pad"
                >
                    <stop
                        offset="18.824%"
                        stopColor="#FFF"
                        stopOpacity={0.251}
                    />
                    <stop
                        offset="63.137%"
                        stopColor="#DEF3FF"
                        stopOpacity={0.498}
                    />
                    <stop offset="100%" stopColor="#ADE1FF" />
                </radialGradient>
                <radialGradient
                    id="ObjMor076__Gradient_12"
                    gradientUnits="userSpaceOnUse"
                    cx={0}
                    cy={0}
                    r={10.688}
                    fx={0}
                    fy={0}
                    gradientTransform="translate(347.7 78.25)"
                    spreadMethod="pad"
                >
                    <stop
                        offset="18.824%"
                        stopColor="#FFF"
                        stopOpacity={0.251}
                    />
                    <stop
                        offset="63.137%"
                        stopColor="#DEF3FF"
                        stopOpacity={0.498}
                    />
                    <stop offset="100%" stopColor="#ADE1FF" />
                </radialGradient>
                <radialGradient
                    id="ObjMor076__Gradient_13"
                    gradientUnits="userSpaceOnUse"
                    cx={0}
                    cy={0}
                    r={25.738}
                    fx={0}
                    fy={0}
                    gradientTransform="translate(261.85 177.6)"
                    spreadMethod="pad"
                >
                    <stop
                        offset="18.824%"
                        stopColor="#FFF"
                        stopOpacity={0.251}
                    />
                    <stop
                        offset="63.137%"
                        stopColor="#DEF3FF"
                        stopOpacity={0.498}
                    />
                    <stop offset="100%" stopColor="#ADE1FF" />
                </radialGradient>
                <radialGradient
                    id="ObjMor076__Gradient_14"
                    gradientUnits="userSpaceOnUse"
                    cx={0}
                    cy={0}
                    r={11.387}
                    fx={0}
                    fy={0}
                    gradientTransform="translate(305.55 226.55)"
                    spreadMethod="pad"
                >
                    <stop
                        offset="18.824%"
                        stopColor="#FFF"
                        stopOpacity={0.251}
                    />
                    <stop
                        offset="63.137%"
                        stopColor="#DEF3FF"
                        stopOpacity={0.498}
                    />
                    <stop offset="100%" stopColor="#ADE1FF" />
                </radialGradient>
                <radialGradient
                    id="ObjMor076__Gradient_15"
                    gradientUnits="userSpaceOnUse"
                    cx={0}
                    cy={0}
                    r={8.325}
                    fx={0}
                    fy={0}
                    gradientTransform="translate(325.9 175.4)"
                    spreadMethod="pad"
                >
                    <stop
                        offset="18.824%"
                        stopColor="#FFF"
                        stopOpacity={0.251}
                    />
                    <stop
                        offset="63.137%"
                        stopColor="#DEF3FF"
                        stopOpacity={0.498}
                    />
                    <stop offset="100%" stopColor="#ADE1FF" />
                </radialGradient>
                <path
                    fill="url(#ObjMor076__Gradient_13)"
                    d="M279.6 195.7q.05-.1.15-.2 7.4-7.4 7.4-17.9 0-10.4-7.4-17.9-7.5-7.4-17.9-7.4-5.25 0-9.7 1.85-4.45 1.85-8.2 5.55-7.4 7.5-7.4 17.9 0 10.5 7.4 17.9 7.4 7.4 17.9 7.4 10.35 0 17.75-7.2z"
                    id="ObjMor076__Layer5_0_MEMBER_0_FILL"
                />
                <path
                    fill="url(#ObjMor076__Gradient_14)"
                    d="M313.5 218.6q-3.35-3.25-7.95-3.25-2.3 0-4.3.8-1.95.85-3.6 2.45-3.3 3.35-3.3 7.95 0 4.65 3.3 7.9 3.25 3.3 7.9 3.3 4.6 0 7.85-3.2l.1-.1q3.25-3.25 3.25-7.9 0-4.6-3.25-7.95z"
                    id="ObjMor076__Layer5_0_MEMBER_1_FILL"
                />
                <path
                    fill="url(#ObjMor076__Gradient_15)"
                    d="M331.75 181.2q2.35-2.35 2.35-5.8 0-3.35-2.35-5.75-2.45-2.4-5.85-2.4-1.65 0-3.1.6-1.45.6-2.65 1.8-2.4 2.4-2.4 5.75 0 3.45 2.4 5.8 2.35 2.4 5.75 2.4t5.75-2.35q.05 0 .1-.05z"
                    id="ObjMor076__Layer5_0_MEMBER_2_FILL"
                />
                <path
                    fill="#FFF"
                    fillOpacity={0.6}
                    d="M236.05 205.5q0-1.35.5-2.5-.9 1.2-1.05 2.75-.05.3-.05.65 0 2.5 1.75 4.3 1.8 1.8 4.3 1.8 1 0 1.9-.3h-.55q-2.8 0-4.8-1.95t-2-4.75m54.9 55.1q-.15-.35-.45-.7-.5-.45-1.2-.45-.75 0-1.2.45-.5.5-.5 1.2v.1q.05.45.2.75.1.2.3.35.45.5 1.2.5.2 0 .45-.05.3-.05.65-.35l.1-.1q.4-.35.5-.95v-.25q0-.25-.05-.5m-12.25 10.1q-3.05-3-3.05-7.3 0-2.05.75-3.8-1.4 1.85-1.6 4.2-.05.5-.05 1.05 0 3.85 2.65 6.5 2.8 2.75 6.6 2.75 1.5 0 2.9-.4h-.9q-4.3 0-7.3-3m-26.9-21q2.3 0 4.3-.65-.6.05-1.35.05-6.4 0-10.95-4.55-4.6-4.55-4.6-11 0-3.05 1.1-5.7-2 2.85-2.35 6.3-.1.8-.1 1.6 0 5.75 4.05 9.8 4.15 4.15 9.9 4.15m8.75-17.25q-.35.3-.45.75-.05.15-.05.35 0 .65.5 1.05.4.45 1.05.45.55 0 1.05-.45.45-.4.45-1.05 0-.6-.45-1.1-.25-.2-.5-.25-.3-.1-.55-.1-.65 0-1.05.35m1.95-4.3q0-1.3-.95-2.2-.9-.9-2.2-.9-1.3 0-2.15.9-.95.9-.95 2.2 0 .9.45 1.6.15.25.5.6.85.9 2.15.9 1.3 0 2.2-.9.8-.75.95-1.75v-.45m-18.3-24.95q-.3.3-.3.8v.05q0 .3.15.5 0 .15.15.2.35.35.75.35.15 0 .3-.05.25-.05.5-.2v-.1q.3-.25.35-.6V204v-.35q-.1-.25-.35-.45-.35-.3-.8-.3-.4 0-.75.3m47.25 34.85q0 2.45 1.7 4.15 1.75 1.75 4.2 1.75.95 0 1.85-.25h-.55q-2.75 0-4.7-1.95-1.95-1.85-1.95-4.6 0-1.35.5-2.45-.9 1.2-1.05 2.7v.65m7.25-4.55q.71.71 1.45 1.25l-.15.15q-.35.3-.35.75v.1q.05.25.15.5.05.1.2.15.3.35.7.35.15 0 .3-.05.2 0 .45-.2 0-.05.05-.1.25-.2.3-.6v-.15q1.822.8 3.95.8 1.6 0 3.05-.45h-.95q-4.55 0-7.8-3.2t-3.25-7.8q0-2.15.8-4.05-1.45 2-1.7 4.5-.05.55-.05 1.1 0 4.1 2.85 6.95m14.5-10.95q0-.25-.05-.5-.15-.4-.5-.75-.55-.5-1.3-.5t-1.25.5q-.55.5-.55 1.25v.15q.05.45.25.8.1.2.3.35.5.55 1.25.55.25 0 .5-.05.35-.1.7-.4l.1-.1q.45-.4.55-1v-.3m-15.45-28.1q-.25-.2-.5-.25-.3-.1-.55-.1-.6 0-1 .35-.35.3-.45.75-.05.15-.05.35 0 .65.5 1.05.4.4 1 .4t1.05-.4q.4-.4.4-1.05t-.4-1.1m-6.3-4.25q0 .9.45 1.6.15.25.45.55.85.9 2.15.9 1.25 0 2.15-.9.8-.75.95-1.7v-.45q0-1.25-.95-2.15-.9-.9-2.15-.9-1.3 0-2.15.9-.9.9-.9 2.15m-16.85 5.35q0-3.05 1.1-5.65-2 2.8-2.35 6.25-.1.8-.1 1.55 0 5.7 4 9.7 4.1 4.1 9.8 4.1 2.25 0 4.25-.65-.6.05-1.35.05-6.3 0-10.8-4.5-4.55-4.5-4.55-10.85m4.2-23.65q-.5-.15-.9-.15-1 0-1.65.6-.55.5-.7 1.2-.1.25-.1.55 0 1.05.8 1.7.65.7 1.65.7.95 0 1.75-.7.65-.65.65-1.7 0-1-.65-1.75-.45-.3-.85-.45m-9.4-6.45q0 1.45.7 2.55.25.45.75.95 1.4 1.45 3.5 1.45 2.05 0 3.5-1.45 1.25-1.2 1.5-2.8v-.7q0-2.05-1.5-3.5-1.45-1.45-3.5-1.45-2.1 0-3.5 1.45-1.45 1.45-1.45 3.5m11.9-25.55q-1.4 1.85-1.6 4.2-.05.5-.05 1.05 0 3.85 2.65 6.5 2.8 2.75 6.6 2.75 1.5 0 2.9-.4h-.9q-4.3 0-7.3-3-3.05-3-3.05-7.3 0-2.05.75-3.8m-15.7-26.55q.95 0 1.85-.25h-.55q-2.75 0-4.7-1.95-1.95-1.85-1.95-4.6 0-1.35.5-2.45-.9 1.2-1.05 2.7v.65q0 2.45 1.7 4.15 1.75 1.75 4.2 1.75m4.15-9.05q-.35-.3-.8-.3-.4 0-.7.3-.35.3-.35.75v.1q.05.25.15.5.05.1.2.15.3.35.7.35.15 0 .3-.05.2 0 .45-.2 0-.05.05-.1.25-.2.3-.6v-.15-.3q-.1-.25-.3-.45m22.75 37.1v.1q.05.45.2.75.1.2.3.35.45.5 1.2.5.2 0 .45-.05.3-.05.65-.35l.1-.1q.4-.35.5-.95v-.25q0-.25-.05-.5-.15-.35-.45-.7-.5-.45-1.2-.45-.75 0-1.2.45-.5.5-.5 1.2m-52.45 33.7q-.15 1.25-.15 2.5 0 9.25 6.5 15.75Q253 200 262.25 200q3.65 0 6.9-1.05-1 .05-2.15.05-10.25 0-17.55-7.3-7.35-7.25-7.35-17.6 0-4.9 1.75-9.15-3.25 4.55-3.8 10.15m39.3-84.2q-.35-.3-.8-.3-.4 0-.7.3-.35.3-.35.75v.1q.05.25.15.5.05.1.2.15.3.35.7.35.15 0 .3-.05.2 0 .45-.2 0-.05.05-.1.25-.2.3-.6v-.15-.3q-.1-.25-.3-.45m-10.05 3.15q0 2.45 1.7 4.15 1.75 1.75 4.2 1.75.95 0 1.85-.25h-.55q-2.75 0-4.7-1.95-1.95-1.85-1.95-4.6 0-1.35.5-2.45-.9 1.2-1.05 2.7v.65M338 212.9q0-.05.05-.1.25-.2.3-.6v-.15-.3q-.1-.25-.3-.45-.35-.3-.8-.3-.4 0-.7.3-.35.3-.35.75v.1q.05.25.15.5.05.1.2.15.3.35.7.35.15 0 .3-.05.2 0 .45-.2m-8.95-1.8q-.9 1.2-1.05 2.7v.65q0 2.45 1.7 4.15 1.75 1.75 4.2 1.75.95 0 1.85-.25h-.55q-2.75 0-4.7-1.95-1.95-1.85-1.95-4.6 0-1.35.5-2.45m-3-28.45q1.2 0 2.25-.35h-.65q-3.35 0-5.75-2.3-2.35-2.3-2.35-5.7 0-1.6.6-2.95-1.1 1.45-1.25 3.3-.05.35-.05.75 0 3 2.05 5.15 2.15 2.1 5.15 2.1m2.8-10.05q.05.35.2.6.05.15.25.25.332.38.8.4v.05q0 5.7 4 9.7 4.1 4.1 9.8 4.1 2.25 0 4.25-.65-.6.05-1.35.05-6.3 0-10.8-4.5-4.127-4.081-4.5-9.7.026-.091.05-.2v-.15q0-.2-.05-.4l-.05-.15v-.25q0-3.05 1.1-5.65-1.68 2.352-2.2 5.15h-.2q-.5 0-.85.35-.45.35-.45.95v.05m24.7-2.3q-.6 0-1 .35-.35.3-.45.75-.05.15-.05.35 0 .65.5 1.05.4.4 1 .4t1.05-.4q.4-.4.4-1.05t-.4-1.1q-.25-.2-.5-.25-.3-.1-.55-.1m-.05-6.05q-.9-.9-2.15-.9-1.3 0-2.15.9-.9.9-.9 2.15 0 .9.45 1.6.15.25.45.55.85.9 2.15.9 1.25 0 2.15-.9.8-.75.95-1.7v-.45q0-1.25-.95-2.15m-26.35-30.6q-.85.05-1.8.05-8.55 0-14.65-6.1-6.1-6.05-6.1-14.65 0-4.1 1.45-7.65-2.7 3.8-3.2 8.45-.1 1.05-.1 2.1 0 7.7 5.4 13.15 5.5 5.55 13.25 5.55 3.05 0 5.75-.9m8.05-22.55q-.45-.15-.75-.15-.85 0-1.4.5-.45.45-.55 1-.1.25-.1.5 0 .85.65 1.4.55.6 1.4.6.8 0 1.45-.6.55-.55.55-1.4 0-.85-.55-1.5-.4-.25-.7-.35m.45-4.8v-.6q0-1.7-1.25-2.9-1.2-1.2-2.95-1.2-1.75 0-2.9 1.2-1.2 1.2-1.2 2.9 0 1.2.6 2.15.2.35.6.8 1.15 1.2 2.9 1.2t2.95-1.2q1.05-1 1.25-2.35m6.9-22.2q-3.05-3-3.05-7.3 0-2.05.75-3.8-1.4 1.85-1.6 4.2-.05.5-.05 1.05 0 3.85 2.65 6.5 2.8 2.75 6.6 2.75 1.5 0 2.9-.4h-.9q-4.3 0-7.3-3M354.8 74q-.15-.35-.45-.7-.5-.45-1.2-.45-.75 0-1.2.45-.5.5-.5 1.2v.1q.05.45.2.75.1.2.3.35.45.5 1.2.5.2 0 .45-.05.3-.05.65-.35l.1-.1q.4-.35.5-.95v-.25q0-.25-.05-.5z"
                    id="ObjMor076__Layer5_1_FILL"
                />
                <g id="ObjMor076__Layer5_0_FILL">
                    <path
                        fill="url(#ObjMor076__Gradient_1)"
                        d="M279.8 255.1q-1.85.8-3.4 2.3-3.05 3.1-3.05 7.45t3.05 7.4q3.05 3.1 7.45 3.1 4.3 0 7.35-3l.1-.1q3.05-3.05 3.05-7.4 0-4.35-3.05-7.45-3.15-3.05-7.45-3.05-2.15 0-4.05.75z"
                    />
                    <path
                        fill="url(#ObjMor076__Gradient_2)"
                        d="M267.35 235.75q0-6.5-4.6-11.2-4.7-4.6-11.2-4.6-3.25 0-6.05 1.15t-5.1 3.45q-4.65 4.7-4.65 11.2 0 6.55 4.65 11.15 4.6 4.65 11.15 4.65 6.45 0 11.1-4.5 0-.05.1-.15 4.6-4.6 4.6-11.15z"
                    />
                    <path
                        fill="url(#ObjMor076__Gradient_3)"
                        d="M246.3 211.3q2-2.05 2-4.9 0-2.8-2-4.85-2.1-2-4.9-2-1.4 0-2.6.5-1.2.5-2.2 1.5-2.05 2.05-2.05 4.85 0 2.85 2.05 4.9 1.95 2 4.8 2 2.8 0 4.85-2h.05z"
                    />
                    <path
                        fill="url(#ObjMor076__Gradient_4)"
                        d="M292.55 233.3q-2 2-2 4.75t2 4.75q1.9 1.95 4.7 1.95 2.75 0 4.7-1.95h.05q1.95-2 1.95-4.75T302 233.3q-2-1.95-4.75-1.95-1.35 0-2.6.5-1.15.45-2.1 1.45z"
                    />
                    <path
                        fill="url(#ObjMor076__Gradient_5)"
                        d="M275.75 186.65q-4.55 4.65-4.55 11.05 0 6.45 4.55 11.05 4.55 4.55 11.05 4.55 6.4 0 10.95-4.45 0-.05.1-.1 4.55-4.6 4.55-11.05 0-6.4-4.55-11.05-4.65-4.55-11.05-4.55-3.25 0-6 1.15t-5.05 3.4z"
                    />
                    <path
                        fill="url(#ObjMor076__Gradient_6)"
                        d="M272.2 107.45q0-2.75-1.95-4.75-2-1.95-4.75-1.95-1.35 0-2.6.5-1.15.45-2.1 1.45-2 2-2 4.75t2 4.75q1.9 1.95 4.7 1.95 2.75 0 4.7-1.95h.05q1.95-2 1.95-4.75z"
                    />
                    <path
                        fill="url(#ObjMor076__Gradient_7)"
                        d="M296.2 137.7q-3.15-3.05-7.45-3.05-2.15 0-4.05.75-1.85.8-3.4 2.3-3.05 3.1-3.05 7.45t3.05 7.4q3.05 3.1 7.45 3.1 4.3 0 7.35-3l.1-.1q3.05-3.05 3.05-7.4 0-4.35-3.05-7.45z"
                    />
                    <path
                        fill="url(#ObjMor076__Gradient_8)"
                        d="M270.4 89.3q-2 2-2 4.75t2 4.75q1.9 1.95 4.7 1.95 2.75 0 4.7-1.95h.05q1.95-2 1.95-4.75t-1.95-4.75q-2-1.95-4.75-1.95-1.35 0-2.6.5-1.15.45-2.1 1.45z"
                    />
                    <path
                        fill="url(#ObjMor076__Gradient_9)"
                        d="M333.8 207.75q-1.35 0-2.6.5-1.15.45-2.1 1.45-2 2-2 4.75t2 4.75q1.9 1.95 4.7 1.95 2.75 0 4.7-1.95h.05q1.95-2 1.95-4.75t-1.95-4.75q-2-1.95-4.75-1.95z"
                    />
                    <path
                        fill="url(#ObjMor076__Gradient_10)"
                        d="M343.65 158.3q-3.25 0-6 1.15t-5.05 3.4q-4.55 4.65-4.55 11.05 0 6.45 4.55 11.05 4.55 4.55 11.05 4.55 6.4 0 10.95-4.45 0-.05.1-.1 4.55-4.6 4.55-11.05 0-6.4-4.55-11.05-4.65-4.55-11.05-4.55z"
                    />
                    <path
                        fill="url(#ObjMor076__Gradient_11)"
                        d="M336 130.8q6.15-6.2 6.15-14.95 0-8.7-6.15-14.95-6.3-6.15-14.95-6.15-4.4 0-8.1 1.55-3.7 1.55-6.85 4.6-6.15 6.25-6.15 14.95 0 8.75 6.15 14.95 6.2 6.15 14.95 6.15 8.65 0 14.8-6 .05-.1.15-.15z"
                    />
                    <path
                        fill="url(#ObjMor076__Gradient_12)"
                        d="M355.15 70.8q-3.15-3.05-7.45-3.05-2.15 0-4.05.75-1.85.8-3.4 2.3-3.05 3.1-3.05 7.45t3.05 7.4q3.05 3.1 7.45 3.1 4.3 0 7.35-3l.1-.1q3.05-3.05 3.05-7.4 0-4.35-3.05-7.45z"
                    />
                </g>
            </defs>
            <use xlinkHref="#ObjMor076__Layer5_0_FILL" />
            <use xlinkHref="#ObjMor076__Layer5_0_MEMBER_0_FILL" />
            <use xlinkHref="#ObjMor076__Layer5_0_MEMBER_1_FILL" />
            <use xlinkHref="#ObjMor076__Layer5_0_MEMBER_2_FILL" />
            <use xlinkHref="#ObjMor076__Layer5_1_FILL" />
        </g></g>
    )
}
export default ObjMor076
